import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { EditPermissions } from '../../../../../../../shared/models';
import { required } from '../../../../../../../shared/utils';
import { getEditTypes } from '../../../delegatorUtils';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';

export interface IsEmptyData {
  name: string,
  description: string,
  variableName: string,
  yes: string,
  no: string
}

export class IsEmpty {

  action: any = {};

  constructor(formData: IsEmptyData) {
    this.action = {
      'actionType': 'isEmpty',
    };
    this.setNodeData(formData);
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
    const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);

    return this.buildForm(formData, editFlows)
  }

  private static getFromData(stepData: { [index: string]: any }): IsEmptyData {
    const action = stepData?.action ? stepData?.action : {};
    const actionParams = action?.actionParams ? action?.actionParams : {};
    const result = action?.result ? action?.result : {};

    return {
      name: action.name ? action.name : '',
      description: action.description ? action.description : '',
      variableName: actionParams.variableName ? actionParams.variableName : '',
      yes: result.yes ? result.yes : newStepValue,
      no: result.no ? result.no : newStepValue,
    }
  }

  private static buildForm(formData: IsEmptyData, editFlows: boolean): UntypedFormGroup {
    return new UntypedFormGroup({
      name: new UntypedFormControl({
        value: formData.name,
        disabled: !editFlows
      }, required('Name')),
      description: new UntypedFormControl({
        value: formData.description,
        disabled: !editFlows
      }, required('Description')),
      variableName: new UntypedFormControl({
        value: formData.variableName,
        disabled: !editFlows
      }, required('Variable Name')),
      yes: new UntypedFormControl(formData.yes),
      no: new UntypedFormControl(formData.no),
    });
  }

  get nodeData(): {} {
    return {
      action: this.action,
      'type': 'action',
      metadata: {
        nodeVersion: '1.0.0'
      }
    };
  }

  setNodeData(formData: IsEmptyData) {
    const {name, variableName, description, yes, no} = formData;

    const actionParams = {
      variableName
    }

    const result = {
      yes,
      no
    }

    this.action = {
      ...this.action,
      name,
      description,
      actionParams,
      result
    }
  }
}

/*
    name: '',
    description: '',
    actionType: 'isEmpty',
    variableName: '',
    yes: newStepValue,
    no: newStepValue,
}*/

/*
{
  action: {
    name: '',
      description: '',
      actionParams: {
      variableName: '',
    },
    result: {
      yes: newStepValue,
        no: newStepValue,
    },
  },
  type: 'action',
}*/
